import { TOGGLE_PRINT_MODE } from '@/store/action-types';

export function togglePrintMode(userID: number | null = null) {
  return {
    type: TOGGLE_PRINT_MODE,
    userID: userID,
  };
}
